<div class="fixture-list-container" *ngFor="let fx of Fixtures">
  <fixture-item [fixture]="fx" [sportName]="SportName"></fixture-item>
</div>
